module.exports = __webpack_public_path__ + "img/toutu.b6cfe920.png";